import {
  ClientSubscriptionIsCancelledError,
  UnexpectedError,
} from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idUser: number;
  idPartner: number;
};

export const setUserPartner = async (params: Params) => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('setUserPartner'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      const { message } = await response.json();

      if (message === m8ErrorMessageMap.CLIENT_SUBSCRIPTION_IS_CANCELLED) {
        throw new ClientSubscriptionIsCancelledError();
      }
    }

    throw new UnexpectedError();
  }
};
